import React, { useEffect, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import Spinner from '../_components/spinner/spinner.component';

import { insertRoutes, disablePaging } from '../_actions/main.actions';
import menus from '../routes';
import AdLogin from '../Pages/ad-login';
import DSALogin from '../Pages/dsa-login';  
import SSOLogin from '../Pages/sso-login';

// import { PrivateRoute } from '../PrivateRoute';

// import Home from '../_layouts/home.component';
// import Blank from '../_layouts/blank.component';
// import Main from '../_layouts/main.component';

const Main = lazy(() => import('../_layouts/main.component'));

const App = (props) => {
  const { insertRoutes, disablePaging } = props;

  useEffect(() => {
    insertRoutes(menus);
    disablePaging();
  }, [insertRoutes, disablePaging]);

  useEffect(() => {
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
  }, []);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Suspense fallback={<Spinner />}>
          {/* <PrivateRoute exact path="/" render={props => <Main {...props} />} /> */}
          {/* <Route path="/home" render={props => <Home {...props} />} /> */}
          {/* <Route path='/main' render={() => <Main />} /> */}
          <Route exact path='/ad_login' render={() => <AdLogin />} /> {/* (signInStatus ? <Redirect from='*' to='/main' /> : null)} />*/}
          <Route exact path='/dsa_login' render={() => <DSALogin />} /> {/* (signInStatus ? <Redirect from='*' to='/main' /> : null)} />*/}
          <Route exact path='/sso_login' render={() => <SSOLogin />} /> {/* (signInStatus ? <Redirect from='*' to='/main' /> : null)} />*/}
          <Route exact path='/' render={() => <Redirect from='*' to='/main' />} /> {/* (signInStatus ? <Redirect from='*' to='/main' /> : null)} />*/}
          <Route path='/main' component={() => <Main />} />
        </Suspense>
      </Switch>
    </BrowserRouter>
  );
};

const mapDispatchToProps = (dispatch) => ({
  insertRoutes: (routes) => dispatch(insertRoutes(routes)),
  disablePaging: () => dispatch(disablePaging())
});

export default connect(null, mapDispatchToProps)(App);
